








import { defineComponent }           from '@vue/composition-api';
import { useGlobals }                from '@/hooks/use-globals';
import { getViewStorePath }          from '@/store/store.helpers';
import { name }                      from '@/views/dynamic-tables/dynamic-tables.route';
import cBreadcrumb                   from '@/components/breadcrumb/breadcrumb.component.vue';
import { useBreadcrumbTranslations } from '@/hooks/use-breadcrumb-translations';
import { Breadcrumbs }               from '@/helpers/variables';
import { ObjectWithStringKeys }      from '@/types';
import cDynamicTablesHeader          from './components/dynamic-tables-header.component.vue';
import cDynamicTablesTableList       from './components/dynamic-tables-table-list.component.vue';

export default defineComponent({
  name: 'vDynamicTables',
  components: {
    cDynamicTablesHeader,
    cDynamicTablesTableList,
    cBreadcrumb,
  },
  setup() {
    const { store } = useGlobals();
    const translations: ObjectWithStringKeys<string> = useBreadcrumbTranslations([ Breadcrumbs.DYNAMIC_TABLES_LIST ]);

    store.dispatch(`${getViewStorePath(name)}/getDynamicTables`);
    return {
      translations,
    };
  },
});
